import React, { Component } from 'react';
import HeaderOne from './header';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

class MainHeader extends Component{
    render(){
        const { presentURL, isAuth } = this.props;
        return(
            <React.Fragment>
                {
                        !isAuth ?
                            ''
                        :
                            <HeaderOne />
                     
                 }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    connection_id: state.tenant.connection_id,
    presentURL: state.tenant.presentURL,
});

export default connect(
    mapStateToProps,
    // mapDispatchToProps
)(withRouter(MainHeader));